export var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["None"] = "none";
    EmployeeStatus["Active"] = "active";
    EmployeeStatus["Inactive"] = "inactive";
})(EmployeeStatus || (EmployeeStatus = {}));
export var SortType;
(function (SortType) {
    SortType["Asc"] = "asc";
    SortType["Desc"] = "desc";
})(SortType || (SortType = {}));
